// extracted by mini-css-extract-plugin
module.exports = {"modalSectionHeaderStyle":"modalSectionHeader_modalSectionHeaderStyle__XMM9l"};